import React from "react"
import Seo from "../components/SEO"
import { StaticImage } from "gatsby-plugin-image"
import "../styles/new.css"
import "../styles/mobilenew.css"

// markup
const Contact = () => {
  return (
    <div>

      <Seo
        title="Get in touch"
        description="Contact Nolan Interiors about your next project"
      />
      {/* footer */}

      <div className="section flexthis">

        <div className="">
          <StaticImage placeholder="dominantColor" className="image contact" src="../images/expph/officeextra2.jpg" alt="herolp" />
        </div>

        <div className="centerthis servicesmobile mobilemargins">
          <article className="article">
            <h3>I WOULD LOVE <br />TO TALK </h3>
            <p>Want to talk with me about designing your home? Ah-mazing. I totally want to talk to YOU. Drop us a line!</p>
            <h3><a href="mailto:hello@nolaninteriors.com">hello@nolaninteriors.com</a></h3>
            <form action="">
              <input type="text" placeholder="NAME" />
              <input type="text" placeholder="EMAIL" />
              <input type="text" placeholder="CONTACT NO." />
              <input type="text" placeholder="REFERENCE" />
              <textarea name="" id="" cols="30" rows="10" />
              <button className="button">SUBMIT</button>
            </form>

            <div className="flexthis">
              <a href="https://facebook.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                className="button centerthis">facebook</a>
              <a href="https://www.instagram.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                className="button centerthis">instagram</a>
              <a href="https://pinterest.com/nolaninteriors/" target="_blank" rel="noopener noreferrer"
                className="button centerthis">pinterest</a>
              <a href="https://www.houzz.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                className="button centerthis">houzz</a>
            </div>

            <div className="flexthis">
              <a href="https://asteriasoft.studio" target="_blank" rel="noopener noreferrer"
                className="button centerthis">Website by Asteriasoft</a>
            </div>
          </article>
        </div>
      </div>



    </div>

  )
}

export default Contact

